import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import Home from "./pages/Home";
import BaseBage from "./pages/BasePage";
import LandDegradation from "./pages/LandDegradation";

import ReloadHandler from "./RelaodHandler";

import store from "./store/store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import ResetPass from "./pages/PasswordReset";
import "react-toastify/dist/ReactToastify.css";
import Monitoring from "./pages/Monitoring";
import Reporting from "./pages/Monitoring/reporting";
import Prediction from "./pages/Prediction";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./components/Theme";
import AdminHomePage from "./pages/Home/AdminPanel";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import AuthPage from "./components/Sign/SignModal";
import EmailVerification from "./pages/EmailVerification";
import AccountActivation from "./pages/AccountActivation";
import useTokenValidator from "./hooks/checkAuth";
import ProtectedRoute from "./components/ProtectedRoute";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/account",
    element: <AuthPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/verify/:token",
    element: <EmailVerification />,
  },
  {
    path: "/activate/:token",
    element: <AccountActivation />,
  },
  {
    path: "/admin/*",
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "index-monitoring/:type/:index",
    element: (
      <ProtectedRoute>
        <BaseBage />
      </ProtectedRoute>
    ),
  },
  {
    path: "map",
    element: (
      <ProtectedRoute>
        <BaseBage />
      </ProtectedRoute>
    ),
  },
  {
    path: "resetpassword/:reset_token",
    element: <ResetPass />,
  },
  {
    path: "monitoring",
    element: (
      <ProtectedRoute>
        <Monitoring />
      </ProtectedRoute>
    ),
  },
  {
    path: "reporting",
    element: (
      <ProtectedRoute>
        <Reporting />
      </ProtectedRoute>
    ),
  },
  {
    path: "prediction",
    element: (
      <ProtectedRoute>
        <Prediction />
      </ProtectedRoute>
    ),
  },
  {
    path: "land-degradation",
    element: (
      <ProtectedRoute>
        <LandDegradation />
      </ProtectedRoute>
    ),
  },
]);
function App() {
  // useTokenValidator();
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ReloadHandler />
        <RouterProvider router={router} />
        <ToastContainer
          position="top-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 9999 }}
        />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
